import { Page } from '../components';
import { PullDataForm } from '../forms';

export const PullData = () => <Page render={() => <PullDataForm />} />;
